<ng-container *ngIf="!item.hidden">
  <span class="navigation-section-text" [translate]="item.translate">{{ item.title }}</span>
  <!-- More icon in collapsed menu -->
  <fa-icon [icon]="'minus'"></fa-icon>
</ng-container>
